import { Company, User } from '../lib';

declare global {
	interface Window {
		hj: (name: string, value: string, opts?: object) => void;
	}
}

interface Config {
	company: Company;
	user: User;
}

export const initializeHotJar = ({ company, user }: Config) => {
	if (!window.hj) return;

	window.hj('identify', user.id, {
		company_id: company.id,
		is_manager: user.is_manager,
		department: user.custom_properties?.department,
		role: user.custom_properties?.role,
		is_admin: user.admin,
		user_mode: user.user_mode,
		translation_setting: user.locale,
		monarch_cohort: company.monarch_cohort,
		company_in_trial: company.status === 'in_trial',
		company_is_demo: company.is_demo,
	});
};
